var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9995 9.5V8.46C6.0935 7.9175 5.4995 7.019 5.4995 6C5.4995 4.343 7.0665 3 8.9995 3C10.9325 3 12.4995 4.343 12.4995 6C12.4995 7.019 11.9055 7.918 10.9995 8.46V9.5H6.9995ZM13.073 12.7015C13.2685 12.575 13.5 12.5 13.75 12.5C14.4405 12.5 15 13.0595 15 13.75C15 14.4405 14.4405 15 13.75 15C13.186 15 12.7145 14.624 12.559 14.1105L9 12.799L5.441 14.1105C5.2855 14.624 4.814 15 4.25 15C3.5595 15 3 14.4405 3 13.75C3 13.0595 3.5595 12.5 4.25 12.5C4.5 12.5 4.7315 12.5755 4.927 12.7015L6.831 12L4.927 11.2985C4.7315 11.425 4.5 11.5 4.25 11.5C3.5595 11.5 3 10.9405 3 10.25C3 9.5595 3.5595 9 4.25 9C4.814 9 5.2855 9.3765 5.441 9.89L9 11.201L12.559 9.8895C12.7145 9.376 13.186 9 13.75 9C14.4405 9 15 9.5595 15 10.25C15 10.9405 14.4405 11.5 13.75 11.5C13.5 11.5 13.2685 11.425 13.073 11.2985L11.169 12L13.073 12.7015ZM10.2495 5.5C10.6635 5.5 10.9995 5.8355 10.9995 6.25C10.9995 6.6645 10.6635 7 10.2495 7C9.8355 7 9.4995 6.6645 9.4995 6.25C9.4995 5.8355 9.835 5.5 10.2495 5.5ZM8.4995 6.25C8.4995 5.8355 8.1635 5.5 7.7495 5.5C7.335 5.5 6.9995 5.8355 6.9995 6.25C6.9995 6.6645 7.3355 7 7.7495 7C8.1635 7 8.4995 6.6645 8.4995 6.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/skull.cfebdd26e95f0cc5bf1a1e870a6dd4e2.svg";
export { ForwardRef as ReactComponent };